export default __webpack_public_path__ + "static/media/deleteRowIcon.4d9c4906.svg";